import { IMenuItem } from '../../models/menu.model';

export const policyValdidationMenu: IMenuItem[] = [
  { path: 'validate', label: 'Validate Policy', id: 'MID_BPP_POLICY_VALIDATE' },
  { path: 'logs', label: 'Validation Logs', id: 'MID_BPP_POLICY_LOGS' },
];

export const policyMenu: IMenuItem = {
  label: `Policy`,
  path: `policy-desk`,
  id: 'MID_POLICY_DESK',
  icon: 'fa fa-book',
  children: [
    // { path: `fraud`, label: `Fraud` },
    // { path: `claim-data`, label: `Claim Data`, id: 'MID_POLICY_CLAIM_DATA' },
    { path: `production-data`, label: `Production Data`, id: 'MID_POLICY_PRODUCTION_DATA' },
    { path: `policy-data`, label: `Policy Data`, id: 'MID_POLICY_POLICY_DATA' },
    ...policyValdidationMenu,
    { path: `commissions`, label: `Policy Commissions`, id: 'MID_POLICY_COMMISSIONS' },
  ],
};
